export const LOADER_SIZE = {
  xs: { height: '80px' },
  sm: { height: '140px' },
  md: { height: '200px' },
  lg: { height: '250px' },
  xl: { height: '350px' },
};
